import request from '@/common/request/request'
export default {
  inviteToJoin: (data, baseURL) => { return request({ url: '/Book/InviteToJoin', method: 'post', data, baseURL }) },
  joinByPhone: (data, baseURL) => { return request({ url: '/Book/JoinByPhone', method: 'post', data, baseURL }) },
}